import { render, staticRenderFns } from "./menuSelect.vue?vue&type=template&id=5d54d5ea&scoped=true"
import script from "./menuSelect.vue?vue&type=script&lang=js"
export * from "./menuSelect.vue?vue&type=script&lang=js"
import style0 from "./menuSelect.vue?vue&type=style&index=0&id=5d54d5ea&prod&lang=less&scoped=true"
import style1 from "./menuSelect.vue?vue&type=style&index=1&id=5d54d5ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d54d5ea",
  null
  
)

export default component.exports